module.exports = __webpack_public_path__ + "img/custom_bg1.74a77510.png";